import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import DatePicker from "@commonComponents/formComponents/CustomDatePicker";
import DeleteIcon from "@commonComponents/deleteIcon";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const SupportingDocForm =(props)=>{
  const {
    dataSource: {
      id,
      expiration,
      reference,
      description,
      issuingAuthority,
      amount,
      type,
      quantity,
      currency = '',
      unitOfMeasurement = ''
    },
    currencyList = [],
    copyDocument,
    translate,
    docCodeList, 
    renderAtLast, 
    onChange, 
    onSelect, 
    onBlur, 
    deleteData, 
    tableName, 
    suppDocIdx, 
    supportingDocValidarion, 
    markedDeleted, 
    isSupportingDocDisabled
  } = props
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value?.trim()}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>{
    if(supportingDocValidarion) supportingDocValidarion(suppDocIdx,name,value)
    onSelect(id,tableName,{[name]:value,id})
},[tableName,id,onSelect,translate])
  const onBlurHandler=useCallback(({target:{value,name}})=>{
    if(supportingDocValidarion) supportingDocValidarion(suppDocIdx,name,value)
    onBlur(tableName,{[name]:value?.trim(),id})
},[tableName,id,onBlur,translate])

const { version, isImportShipment ,serviceType} = useCurrentShipmentType()
const isDMS = version === 'DMS'
  
  return (
    <div  className="formContainer"> 
      <div className="actionbtns">
        {copyDocument && copyDocument(translate)}
      </div> 
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`type-${id}`}
            name="type"
            clearable
            labelClass="text-none"
            label="DOC_CODE"
            data={docCodeList}
            value={type}
            text={type}
            onChange={onDropDownChange}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>

        <Grid.Column>
          <InputField
            id={`reference-${id}`}
            name="reference"
            type="text"
            label="REF"
            value={reference}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <DatePicker  
            id={`expiration-${id}`}
            name="expiration"
            type="date"
            label="EXPIRATION"
            clearInput={false}
            value={expiration}     
            onChange={onDropDownChange}
            isDisabled={isSupportingDocDisabled}
          />
          
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`description-${id}`}
            type="text"
            value={description}
            name="description"
            label="LINE"
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`issuingAuthority-${id}`}
            type="text"
            name="issuingAuthority"
            value={issuingAuthority}
            label="AUTHORITY"
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`amount-${id}`}
            type="number"
            name="amount"
            value={amount}
            label="AMOUNT"
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>
        {isDMS && (
          <Grid.Column>
            <DropDown
              id={`currency-${id}`}
              label="CURRENCY"
              labelClass='text-none'
              direction='left'
              data={currencyList}
              clearable
              value={currency}
              text={currency}
              name='currency'
              onChange={onDropDownChange}
              isDisabled={isSupportingDocDisabled}
            />
          </Grid.Column>
        )}
        <Grid.Column>
          <InputField
            id={`quantity-${id}`}
            type="number"
            name="quantity"
            value={quantity}
            label="QUANTITY"
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isSupportingDocDisabled}
          />
        </Grid.Column>
        {renderAtLast && renderAtLast({
          id,
          currency,
          quantity, 
          unitOfMeasurement,
          onChangeHandler,
          onBlurHandler,
          onDropDownChange,
          isSupportingDocDisabled
        })}
      </Grid.Row>
      <div className="actionbtns">
        {markedDeleted?markedDeleted({id, tableName}):
       <DeleteIcon onClick={()=>deleteData(id,tableName)} />}
    </div>
      </div>
   
  );
}
SupportingDocForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(SupportingDocForm)
